export default "__VITE_ASSET__DZnpMYH4__"